//异卡发放
import { $http, buildHeaders } from "./index";

//获取列表
export const diffbank_list = (params) => {
  return $http.get("/admin/DiffBank/index", { params });
};

//获取异卡发放记录详情
export const diffbank_detail = (id) => {
  return $http.get("/admin/DiffBank/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//审核
export const diffbank_check = (data) => {
  return $http.post("/admin/DiffBank/check", data, {
    headers: buildHeaders(3),
  });
};
